// Zentrale Konfiguration – Kontaktdaten hier an EINER Stelle pflegen.
// Hinweis: Schweizer Schreibweise (ss statt ß) auf der gesamten Website.

export const SITE = {
  name: "Schweisstechnik Steyskal",
  shortName: "Steyskal",
  owner: "Patrizia Steyskal",
  claim: "Präzision verbindet.",
  phoneDisplay: "+41 79 840 44 49",
  phoneHref: "tel:+41798404449",
  email: "info@schweisstechnik-steyskal.ch",
  addressLine1: "Binzstrasse 3",
  addressLine2: "8953 Dietikon",
  city: "Dietikon",
  canton: "ZH",
  region: "Schweiz",
  uid: "CHE-401.651.550",
  mapsUrl: "https://maps.google.com/?q=Binzstrasse+3,+8953+Dietikon",
};

export const NAV_LINKS = [
  { id: "leistungen", label: "Leistungen" },
  { id: "prozess", label: "Wie wir arbeiten" },
  { id: "galerie", label: "Galerie" },
  { id: "kontakt", label: "Kontakt" },
];

export const SERVICES = [
  {
    id: "mobil",
    icon: "Clock",
    title: "Mobile Schweißarbeiten.",
    desc: "Unsere Schweißer kommen zu Ihnen – Baustelle, Hof oder Betrieb in der ganzen Schweiz. Mit eigenem Equipment und Erfahrung.",
    meta: "Schweizweit",
  },
  {
    id: "projekte",
    icon: "ClipboardList",
    title: "Projektarbeiten.",
    desc: "Wir übernehmen Schweißprojekte mit unserem eigenen Team – zuverlässig, termingerecht und sauber ausgeführt.",
    meta: "Stahlbau, Anlagenbau",
  },
  {
    id: "reparaturen",
    icon: "Award",
    title: "Reparaturen & Instandhaltung.",
    desc: "Kaputte Teile oder Anlagen? Unsere Schweißer reparieren pragmatisch und haltbar – in der Werkstatt oder vor Ort.",
    meta: "Schnell & zuverlässig",
  },
  {
    id: "beratung",
    icon: "MessageCircle",
    title: "Beratung & Planung.",
    desc: "Sie haben eine Idee oder ein Problem? Wir beraten ehrlich, was sinnvoll ist und wie wir es mit unserem Team umsetzen.",
    meta: "Persönlich & direkt",
  },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Anfrage.",
    desc: "Sie schildern kurz Ihr Projekt oder Problem – per Telefon oder Formular.",
  },
  {
    num: "02",
    title: "Besichtigung oder Beratung.",
    desc: "Wir kommen zu Ihnen oder klären telefonisch, was genau gebraucht wird und welche Lösung passt.",
  },
  {
    num: "03",
    title: "Festes Angebot.",
    desc: "Sie erhalten ein transparentes Angebot mit Zeitplan und Preis – ohne Überraschungen.",
  },
  {
    num: "04",
    title: "Ausführung durch unser Team.",
    desc: "Unsere eigenen Schweißer führen die Arbeit aus – sauber, präzise und zum vereinbarten Termin.",
  },
];

export const GALLERY_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_schweiss-pro/artifacts/rgeg7mu7_18023892-9edf-4fa0-bec0-9c7464e8f2c0.webp",
    alt: "Rohrschweissung an einer Fernwärmeleitung im Detail – Projektfoto",
    caption: "Rohrschweissung im Detail",
    tag: "Projekt",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_schweiss-pro/artifacts/0jlvr1m8_4fd9c1fc-1975-4c3c-86c2-e78d85fb528f.webp",
    alt: "Verlegung und Verschweissung einer Fernwärmeleitung im Rohrgraben – Projektfoto",
    caption: "Rohrleitungsbau vor Ort",
    tag: "Projekt",
  },
  {
    src: "https://images.unsplash.com/photo-1558611997-dd5b20e08c71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    alt: "Schweissnaht im Entstehen – Detailaufnahme",
    caption: "Naht im Entstehen",
    tag: "Symbolbild",
  },
  {
    src: "https://images.unsplash.com/photo-1667892702884-faa077e80d7b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    alt: "Gebürstete Metalloberfläche im Detail",
    caption: "Material im Detail",
    tag: "Symbolbild",
  },
];
